<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-passing-grade-alumni" data-bs-toggle="modal" data-bs-target="#passing-grade-alumni-modal-form">Klik</button>
        <div class="modal" id="passing-grade-alumni-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Nama<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan nama" v-model="form.name" required oninvalid="this.setCustomValidity('Masukan nama')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label class="form-label">Sekolah<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <v-select
                                                    :options="dataSchool"
                                                    label="name"
                                                    v-model="form.school"
                                                    placeholder="Pilih Sekolah"
                                                    :disabled="$parent.users.role != 'administrator' ? true:false"
                                                    @input='set_school_Id'
                                                    >
                                                    <template #search="{attributes, events}">
                                                        <input
                                                        class="vs__search"
                                                        :required="!form.school"
                                                        v-bind="attributes"
                                                        v-on="events"
                                                        />
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Universitas<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <v-select
                                                    :options="dataUniversity"
                                                    label="name"
                                                    v-model="form.university"
                                                    placeholder="Pilih Universitas"
                                                    @input='set_university_id();'
                                                    >
                                                    <template #search="{attributes, events}">
                                                        <input
                                                        class="vs__search"
                                                        :required="!form.university"
                                                        v-bind="attributes"
                                                        v-on="events"
                                                        />
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Jurusan<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <v-select
                                                    :options="dataMajor"
                                                    label="major_fullname"
                                                    v-model="form.major"
                                                    placeholder="Pilih Jurusan"
                                                    @input='set_major_id();'
                                                    >
                                                    <template #search="{attributes, events}">
                                                        <input
                                                        class="vs__search"
                                                        :required="!form.major"
                                                        v-bind="attributes"
                                                        v-on="events"
                                                        />
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="form-label">Tahun Lulus<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper form-select-style-1">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <select class="form-select form-select-box-1" v-model="form.graduation_year" required oninvalid="this.setCustomValidity('Pilih Tahun Lulus')" oninput="this.setCustomValidity('')">
                                                    <option value="">Pilih Tahun Lulus</option>
                                                    <option v-for="(item, index) in dataYear" :key="index" :value="item.id">{{ item.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="d-block">
                                            <label class="form-label">Detail Rapor</label>
                                            <div class="d-flex align-items-center pt-3">
                                                <div class="form-group me-5">
                                                    <label class="d-flex align-items-center">
                                                        <input class="form-check-input m-0" type="radio" name="detailRapor" :checked="form.detail_score == 1 ? 'checked':''" value="1" v-model="form.detail_score" @change="setScoreDefault($event)">
                                                        <div class="d-block ms-2 font-bold text-sm">Ada</div>
                                                    </label>
                                                </div>
                                                <div class="form-group">
                                                    <label class="d-flex align-items-center">
                                                        <input class="form-check-input m-0" type="radio" name="detailRapor" :checked="form.detail_score == 0 ? 'checked':''" value="0" v-model="form.detail_score">
                                                        <div class="d-block ms-2 font-bold text-sm">Tidak Ada</div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">PM Rapor<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input :disabled="form.detail_score == 1 ? true:false" type="text" class="form-control" placeholder="Masukan nilai" v-model="form.score_passing_grade" required oninvalid="this.setCustomValidity('Masukan nilai')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="form.detail_score == 1">
                                <div class="d-block mb-4">
                                    <ul class="nav nav-tabs">
                                        <li class="nav-item" v-for="(item, index) in form.total_semester" :key="index">
                                            <a class="nav-link" :class="item == semester_active ? 'active':''" href="javascript:void(0)" v-on:click="setSemester(item)">Semester {{ item }}</a>
                                        </li>
                                    </ul>
                                </div>

                                <div v-for="(itemSemester, indexSemester) in form.total_semester" :key="indexSemester" :class="itemSemester == semester_active ? 'd-block':'d-none'">
                                    <div class="row" v-if="dataSubject.length <= divider">
                                        <div class="col-6">
                                            <div class="d-flex justify-content-end">
                                                <div class="d-block small font-bold pe-3 me-2">On/Off</div>
                                            </div>
                                            <table class="table border-0 table-sm-td table-hover">
                                                <tbody>
                                                    <tr v-for="(item, index) in dataSubject" :key="index">
                                                        <td class="font-bold">
                                                            <div class="block-ellipsis block-190">{{item.name}}</div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group form-style-1 m-0 form-style-1-number">
                                                                <input type="text" class="form-control form-control-number" v-model="form.subject_list[itemSemester][item.id].score">
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="d-flex align-items-center justify-content-end">
                                                                <div class="form-check form-switch">
                                                                    <input class="form-check-input" type="checkbox" v-model="form.subject_list[itemSemester][item.id].active" :checked="form.subject_list[itemSemester][item.id].active == 1 ? 'checked':''" true-value="1" false-value="0">
                                                                    <label class="form-check-label"></label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="row" v-if="dataSubject.length > divider">
                                        <div class="col-6">
                                            <div class="d-flex justify-content-end">
                                                <div class="d-block small font-bold pe-3 me-2">On/Off</div>
                                            </div>
                                            <table class="table border-0 table-sm-td table-hover">
                                                <tbody>
                                                    <tr v-for="(item, index) in firstHalf" :key="index">
                                                        <td class="font-bold">
                                                            <div class="block-ellipsis block-190">{{item.name}}</div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group form-style-1 m-0 form-style-1-number">
                                                                <input type="text" class="form-control form-control-number" v-model="form.subject_list[itemSemester][item.id].score">
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="d-flex align-items-center justify-content-end">
                                                                <div class="form-check form-switch">
                                                                    <input class="form-check-input" type="checkbox" v-model="form.subject_list[itemSemester][item.id].active" :checked="form.subject_list[itemSemester][item.id].active == 1 ? 'checked':''" true-value="1" false-value="0">
                                                                    <label class="form-check-label"></label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-flex justify-content-end">
                                                <div class="d-block small font-bold pe-3 me-2">On/Off</div>
                                            </div>
                                            <table class="table border-0 table-sm-td table-hover">
                                                <tbody>
                                                    <tr v-for="(item, index) in secondHalf" :key="index">
                                                        <td class="font-bold">
                                                            <div class="block-ellipsis block-190">{{item.name}}</div>
                                                        </td>
                                                        <td>
                                                            <div class="form-group form-style-1 m-0 form-style-1-number">
                                                                <input type="text" class="form-control form-control-number" v-model="form.subject_list[itemSemester][item.id].score">
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="d-flex align-items-center justify-content-end">
                                                                <div class="form-check form-switch">
                                                                    <input class="form-check-input" type="checkbox" v-model="form.subject_list[itemSemester][item.id].active" :checked="form.subject_list[itemSemester][item.id].active == 1 ? 'checked':''" true-value="1" false-value="0">
                                                                    <label class="form-check-label"></label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-passing-grade-alumni">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="button" class="btn btn-white btn-s-1 me-3" v-on:click="generateScore" v-if="form.detail_score == 1">
                                        <div class="btn-s-1-inner">Generate</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'PassingGradeAlumniForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id                      : "",
                name                    : "",
                group                   : "rapor",
                school_id               : "",
                university_id           : "",
                major_id                : "",
                graduation_year         : "",
                total_semester          : 5,
                detail_score            : 0,
                score_passing_grade     : "",
                subject_list            : {},
                school      : [],
                university  : [],
                major       : []
            },
            semester_active : 1,
            dataUniversity  : [],
            dataSchool      : [],
            dataMajor       : [],
            dataYear        : [],
            dataSubject     : [],
            firstHalf       : [],
            secondHalf      : [],
            divider         : 5,
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            school_id: {
                required
            },
            university_id: {
                required
            },
            major_id: {
                required
            },
            graduation_year: {
                required
            },
            score_passing_grade: {
                required
            }
        }
    },
    methods: {
        set_school_Id: function() {
            if(this.form.school.id !== undefined) {
                this.form.school_id = this.form.school.id
            }  else {
                this.form.school_id = "";
            }
        },
        set_university_id: function() {
            this.form.major     = [];
            this.form.major_id  = "";
            if(this.form.university.id !== undefined) {
                this.form.university_id = this.form.university.id
            }  else {
                this.form.university_id = "";
            }

            this.getMajor();
        },
        set_major_id: function() {
            if(this.form.major.id !== undefined) {
                this.form.major_id = this.form.major.id
            }  else {
                this.form.major_id = "";
            }
        },        
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getSchool: function() {
            let partner = 0;

            if(this.$parent.users.role != 'administrator') {
                partner = 1;
            }

            let uri         = process.env.VUE_APP_APIHOST+'school/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000,
                    partner  : partner
                }
            }).then(res => {
                this.dataSchool = res.data.data;

                if ((this.$parent.users.school_id !== undefined) && (this.$parent.users.school_id !== null) && (this.$parent.users.school_id !== "")) {
                    this.form.school_id = this.$parent.users.school_id;

                    this.dataSchool.forEach(element => {
                        if(element.id == this.form.school_id) {
                            this.form.school = element
                        }
                    });
                }
        });
        },
        getMajor: function() {
            this.form.major_id = "";
            let uri         = process.env.VUE_APP_APIHOST+'major/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000,
                    university_id : this.form.university_id,
                    filter_by_university : 1
                }
            }).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        getYear: function() {
            let uri         = process.env.VUE_APP_APIHOST+'year/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataYear = res.data.data;
            });
        },
        getSubject: function() {
            let uri         = process.env.VUE_APP_APIHOST+'subject/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataSubject    = res.data.data;
                let divider         = this.dataSubject.length / 2;
                this.divider        = divider;

                if (this.dataSubject.length > divider) {
                    this.firstHalf = this.dataSubject.slice(0, this.dataSubject.length / 2);
                    this.secondHalf = this.dataSubject.slice(this.dataSubject.length / 2);
                }

                for (let index = 1; index <= this.form.total_semester; index++) {
                    this.form.subject_list[index] = {};
                    this.dataSubject.forEach(element => {
                        this.form.subject_list[index][element.id] = {
                            id : element.id,
                            score : '',
                            active : 0
                        };
                    });
                }

            });
        },
        loadForm: function(params="") {
            this.getSchool();
            this.getUniversity();
            this.getYear();
            this.getSubject();            

            if(params == '') {
                this.label = 'Tambah';
                this.clearData();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-passing-grade-alumni').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-passing-grade-alumni').click();
            this.$parent.$children[0].$children[0].getData();
            this.clearData();
        },
        clearData: function() {
            for (let key in this.form) {
                if(key == 'subject_list') {
                    for (let index = 1; index <= this.form.total_semester; index++) {
                        this.form.subject_list[index] = {};
                        this.dataSubject.forEach(element => {
                            this.form.subject_list[index][element.id] = {
                                id : element.id,
                                score : '',
                                active : 0
                            };
                        });
                    }
                }

                else if(key == 'detail_score') {
                    this.form.detail_score = 0;
                }
                
                else if(key == 'total_semester') {
                    this.form.total_semester = 5;
                }
                
                else if(key == 'group') {
                    this.form.group = 'rapor';
                }
                
                else if(key == 'school_id') {
                    if ((this.$parent.users.school_id !== undefined) && (this.$parent.users.school_id !== null) && (this.$parent.users.school_id !== "")) {
                        this.form.school_id = this.$parent.users.school_id;

                        this.dataSchool.forEach(element => {
                            if(element.id == this.form.school_id) {
                                this.form.school = element
                            }
                        });
                    }
                }
                
                else {
                    this.form[key] = '';
                }
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();

                for (let key in this.form) {
                    if(key == 'subject_list') {
                        formData.append('subject_list', JSON.stringify(this.form.subject_list));
                    } else {
                        formData.append(key, this.form[key]);
                    }
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-alumni/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });
            }
        },
        getDataByID: function(id) {
            if(id != '') {
                this.clearData();
                let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                        group : this.form.group
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets     = res.data.data;
                        let detail_score = 1;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];
                                
                                if(key == 'detail_score') {
                                    if(datasets[key] == 0) {
                                        for (let index = 1; index <= this.form.total_semester; index++) {
                                            this.form.subject_list[index] = {};

                                            this.dataSubject.forEach(element => {
                                                this.form.subject_list[index][element.id] = {
                                                    id : element.id,
                                                    score : '',
                                                    active : 1
                                                };
                                            });
                                        }

                                        detail_score = 0;
                                    }
                                }

                                if(key == 'score_list') {
                                    if(detail_score == 1) {
                                        this.form.subject_list = datasets[key];
                                    }
                                }

                                if(key == 'university_id') {
                                    this.getMajor();
                                }
                            }
                        }
                    }
                });
            }
        },
        setSemester: function(params) {
            this.semester_active = params;
        },
        generateScore: function() {
            let formData = new FormData();

            for (let key in this.form) {
                if(key == 'subject_list') {
                    formData.append('subject_list', JSON.stringify(this.form.subject_list));
                } else {
                    formData.append(key, this.form[key]);
                }
            }

            this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-alumni/generate-score', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                if (response.data.status) {
                    this.$swal({
                        icon: 'success',
                        title: 'Success',
                        text: response.data.message,
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            this.form.score_passing_grade = response.data.score_passing_grade;
                        }
                    });
                } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                }
                this.waiting = false;
            })
            .catch(function () {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
                return;
            });
        },
        setScoreDefault: function() {
            this.form.score_passing_grade = "";
        }
    },
}
</script>
